import {Component, OnInit} from '@angular/core';
import {UserPreferencesService} from './modules/shared/service/user-preferences.service';
import {TranslateService} from '@ngx-translate/core';
import {LocalizationService} from './modules/shared/service/localization.service';
import {Router} from '@angular/router';
import {AuthorizationService} from './modules/shared/service/authorization.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  public areTranslationsLoading: boolean;

  constructor(private userPreferencesService: UserPreferencesService, private translate: TranslateService,
              private localizationService: LocalizationService, private authorizationService: AuthorizationService) {}

  ngOnInit() {
    this.areTranslationsLoading = true;
    this.authorizationService.refreshTokensIfNeeded();
    this.localizationService.getStartingLanguage().subscribe(language => {
      this.translate.use(language).subscribe(() => this.areTranslationsLoading = false);
    });
  }

  public getFont(): string {
    return this.userPreferencesService.getFont();
  }

  public getTextColor(): string {
    return this.userPreferencesService.getTextColor();
  }

  public backgrounds: any = [
    {
      small: '/assets/backgrounds/small/A.jpg',
      src: '/assets/backgrounds/A.jpg'
    },
    {
      small: '/assets/backgrounds/small/B.jpg',
      src: '/assets/backgrounds/B.jpg'
    },
    {
      small: '/assets/backgrounds/small/C.jpg',
      src: '/assets/backgrounds/C.jpg'
    },
    {
      small: '/assets/backgrounds/small/D.jpg',
      src: '/assets/backgrounds/D.jpg'
    },
    {
      small: '/assets/backgrounds/small/E.jpg',
      src: '/assets/backgrounds/E.jpg'
    },
    {
      small: '/assets/backgrounds/small/F.jpg',
      src: '/assets/backgrounds/F.jpg'
    }
  ];
}

